<template>
  <el-dialog :title="mytitle" :visible.sync="dialogFormVisible" custom-class="list-dialog" center :append-to-body="true"
             :close-on-click-modal="false" @close="afterCloseDialog"
  >
    <div class="search-content write-order">
      <el-row>
        <!--@keyup.enter.native="bindGrid"-->
        <el-col :span="24" class="toobar">
          <el-col :span="5">
            <AutoCustomer @handleSelect="select" :splitByAddress="true"></AutoCustomer>
          </el-col>
          <el-col :span="19">
            <!--<el-button type="primary" @click="showdailog('86e6612f-4c47-4ac8-8758-75a8071c5245')">点我测试</el-button>-->
          <span style="float: left;margin-top: 8px;font-size: larger;margin-left: 5px"
                v-if="deliveryaddress==''?false:true">  门店：<span>{{this.deptname}}&nbsp;{{this.customerserial}}</span>&nbsp;&nbsp;收获地址：<span>{{this.deliveryaddress}}</span>
            </span>
            <el-select v-model="cangkucode" size="small" @change="changeCangKu"
                       v-if="deliveryaddress==''?false:true"
                       style="width: 130px;display: block;margin: auto;float: left;margin-left: 30px;">
              <el-option v-for="item in jxcstoreData" :key="item.cangkucode"
                         :label="item.cangkuname"
                         :value="item.cangkucode"
              >
              </el-option>
            </el-select>
          </el-col>
          <!--</div>-->
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <iframe width=100% scrolling="Auto" :height="tableHeight(122)" frameborder="0" name="writeorder"></iframe>
        </el-col>
      </el-row>
    </div>
    <HsCstagreementList ref="HsCstagreementList"></HsCstagreementList>
  </el-dialog>


</template>

<script>

  import {independentDept} from '@/api/set/dept';
  import {simulationLogin,webPath} from '@/api/login';
  import {cusandptbyind} from '@/api/set/jxcstore';
  import HsCstagreementList from './HsCstagreementList';

  export default {
    inject: ["afterCloseDialog"],
    name: 'HelloWorld',
    data() {
      return {
        activeIndex: '1',
        msg: 'Welcome to Your Vue.js App',
        dialogFormVisible: false,
        searchdata: "",
        myunitgroup: this.unitgroup,
        mytitle: this.title,
        loading: true,
        servedserial: "",
        idd: [],
        tableData: [],
        pinyinData: [],
        coupon: '',
        province: '',//省
        city: '',//市
        county: '',//县
        couponServedserial: '',//独立核算
        deliveryaddress: '',//收货地址
        deptname: '',
        loginName: '',
        customerserial: '',
        restaurants: [],
        timeout: null,
        elinkman: '',
        elinkmantel: '',
        jxcstoreData: [],//仓库数组
        cangkucode: '',//选中的仓库
        settingmenthod:'',
      }
    },
    props: {
      unitgroup: {
        default: 1
      },
      title: {
        default: "客户信息"
      },
      parentcustomerserial: {//上级客户编码
        default: ""
      },
      filterbyservedserial: {//根据当前登录人所属的加工中心过滤数据
        default: false
      },
      storeInfo: {
        default: ""
      }
    },
    methods: {


      changeCangKu() {
        localStorage.setItem('cangkucode', this.cangkucode);
        try {
          window.writeorder.window.refreshErWeiTable()
        } catch (ee) {
        }
      },

      //客户地址
      select(customerserial, customername, row) {
        this.settingmenthod=''
        this.deliveryaddress = row.deliveryaddress
        this.elinkman = row.linkman
        this.elinkmantel = row.linkmantel
        this.deptname = row.deptname
        this.customerserial = row.customerserial
        var settingmenthods = row.settingmenthod.split(',');
        for (let i = 0; i < settingmenthods.length; i++) {
          if (settingmenthods[i] == '全额现结') {
            settingmenthods[i] = 100
          } else if (settingmenthods[i] == '月结') {
            settingmenthods[i] = 200
          }
          if (this.settingmenthod) {
            this.settingmenthod=this.settingmenthod+','+settingmenthods[i]
          }else {
            this.settingmenthod=settingmenthods[i]+''
          }
        }
        //客户信息
        simulationLogin({loginName: this.loginName, customerserial: this.customerserial}).then(response => {
          if (response.data.code == 0) {
            localStorage.setItem('hpweb_token', response.data.token); //兼容vue端的相关页面
            localStorage.setItem('keFTtoken', response.data.token); //token
            localStorage.setItem('keFuInfoModel', JSON.stringify(response.data.obj)); //用户信息
            localStorage.setItem('domain', webPath());
            localStorage.setItem('deliveryaddress', this.deliveryaddress);
            localStorage.setItem('elinkman', this.elinkman);
            localStorage.setItem('elinkmantel', this.elinkmantel);
            localStorage.setItem('cangkucode', this.cangkucode);
            localStorage.setItem('settingmenthod', this.settingmenthod);
            if (this.settingmenthod.indexOf("100")>-1) {//现金支付
              window.open("http://" + webPath() + "/H5/html/gouWuChe/gouWuChe.html", 'writeorder', false)
            }else {//月结
              window.open("http://" + webPath() + "/H5/html/DaiFaHuo/dingDan/dingDan_main.html", 'writeorder', false)
            }
          } else {
            this.$message({
              type: 'warning',
              duration: 1500,
              message: response.data.msg
            });
          }
        })
      },
      showdailog(groupguid) {
        this.$refs.HsCstagreementList.bindGrid(groupguid)
      },

      add() {
        this.$refs.DataContactEdit.initForm()
        this.OpenDialog()
      },
      OpenDialog() {
        this.$refs.DataContactEdit.show()
      },
      show(unitgroup, title) {
        this.cangkucode = ''//选中的仓库
        this.searchdata = ''//选中的门店
        this.deliveryaddress = ''//收货地址
        this.restaurants = []
        this.pinyinData = []
        this.coupon = ''
        this.province = ''//省
        this.city = ''//市
        this.county = ''//县
        this.couponServedserial = ''//独立核算
        if (unitgroup) {
          this.myunitgroup = unitgroup
        }
        if (title) {
          this.mytitle = title
        }
        this.dialogFormVisible = true
        if (this.storeInfo) {
          this.coupon = this.storeInfo.coupon
          this.province = this.storeInfo.province//省
          this.city = this.storeInfo.city//市
          this.county = this.storeInfo.county//县
          this.couponServedserial = this.storeInfo.independentserial//独立核算
        }
        this.cusandptbyind();
      },
      cusandptbyind() {
        //根据登录人过滤仓库
        cusandptbyind({}).then(response => {
          this.jxcstoreData = response.data.obj
          //默认仓库
          if (this.userInfoModel.cangku) {
            let temp1 = this.userInfoModel.cangku.split(";")
            biaoji:
              for (let i in temp1) {
                for (let j in  this.jxcstoreData) {
                  if (temp1[i] == this.jxcstoreData[j].cangkucode) {
                    this.cangkucode = temp1[i]
                    break biaoji;
                  }
                }
              }

          } else {
            this.cangkucode = this.jxcstoreData[0].cangkucode
          }
        })

      },
    },
    mounted() {

      window.showdailog = (groupguid) => {
        this.showdailog(groupguid)
      }
      this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
      this.servedserial = this.userInfoModel.independentserial;
      //默认值
      if (!this.userInfoModel.independentserial) {
        independentDept().then(response => {
          this.idd = response.data.obj
          if (this.userInfoModel.independentserial == "") {
            this.idd.unshift({serialnum: "all", dname: "全部"})
            this.servedserial = 'all';
          }

        })
      }
    },
    components: {
      HsCstagreementList
    }

  }


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  /*.el-table td, .el-table div, .el-table .cell {*/
  /*line-height: 23px;*/
  /*padding: 0px;*/
  /*color: red;*/
  /*}*/


</style>




// WEBPACK FOOTER //
// src/components/testorder/cstagreement/WriteOrder.vue